import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 38.62 38.62"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#111",
  d: "M3.277 38.62a3.15 3.15 0 0 1-2.306-.97 3.15 3.15 0 0 1-.97-2.307V3.276A3.15 3.15 0 0 1 .971.969a3.15 3.15 0 0 1 2.306-.97h32.067a3.15 3.15 0 0 1 2.306.97 3.15 3.15 0 0 1 .97 2.307v32.067a3.15 3.15 0 0 1-.97 2.307 3.15 3.15 0 0 1-2.306.97Zm0-2.578h32.067a.67.67 0 0 0 .481-.218.67.67 0 0 0 .218-.481V3.276a.67.67 0 0 0-.218-.481.67.67 0 0 0-.481-.219H3.277a.67.67 0 0 0-.481.219.67.67 0 0 0-.218.481v32.067a.67.67 0 0 0 .218.481.67.67 0 0 0 .481.218m-.7-33.465"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#244bf5",
  d: "M8.394 30.136h14.57v-2.577H8.394Zm0-9.537h21.835v-2.578H8.394Zm0-9.537h21.835V8.484H8.394Z",
  "data-name": "article_FILL0_wght300_GRAD0_opsz48"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "IconArticle"}) } }